import { createCrudApi } from '@/libs/api/crud'
import {
  CreatePersonRequest,
  Person,
  PersonPrimaryKey,
  UpdatePersonRequest,
} from './types'

export const peopleApi = createCrudApi<
  Person,
  PersonPrimaryKey,
  CreatePersonRequest,
  UpdatePersonRequest
>('/api/people')
